import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-communication-management',
  standalone: true,
  imports: [],
  templateUrl: './communication-management.component.html',
  styleUrl: './communication-management.component.scss',
})
export class CommunicationManagementComponent implements OnInit {
  constructor(private toastr: ToastrService) {}
  ngOnInit(): void {
    this.toastr.warning('Not implemented yet.');
  }
}
